import { render, staticRenderFns } from "./warningAdd.vue?vue&type=template&id=543560dc&scoped=true&"
import script from "./warningAdd.vue?vue&type=script&lang=js&"
export * from "./warningAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "543560dc",
  null
  
)

export default component.exports